import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { dismissNotification, getDismissedNotification } from "../../services/defs/internal-api";

/**
 * Hook to dismiss a specific in-app notification
 * @returns Mutation function and state for dismissing an notification
 * Currently - used for in app promotions
 */

export const getDismissedNotificationHook = (userId: string, notificationId: string, enabled: boolean = true) => {
	return useQuery({
		queryKey: ["in-app-promotion-dismissed", userId, notificationId],
		queryFn: () => getDismissedNotification(userId, notificationId),
		enabled: enabled && !!userId && !!notificationId,
		meta: {
			disableDefaultErrorHandling: true,
		},
	});
};

export const dismissNotificationHook = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ userId, notificationId }: { userId: string; notificationId: string }) =>
			dismissNotification(userId, notificationId),
		onSuccess: (_, { notificationId }) => {
			queryClient.invalidateQueries({ queryKey: ["in-app-promotion", notificationId] });
		},
	});
};
